import { PARTNER_ID } from "../../constants";
import getPartnerIdKey from "../getPartnerIdKey";

const isValidCountry = (browseCountry, production) => {
  const partnerIdKey = getPartnerIdKey(browseCountry, production);

  if (!partnerIdKey) {
    return false;
  }

  return partnerIdKey in PARTNER_ID;
};

export default isValidCountry;
